import React from 'react';
import { FileText } from 'lucide-react';

const NotesMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-5 h-[380px] flex flex-col shadow-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Notes</h3>
        <div className="flex items-center gap-2">
          <button className="h-8 px-3 rounded-full text-xs font-medium bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center gap-1">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            New Note
          </button>
        </div>
      </div>

      {/* Note Content */}
      <div className="flex-1 flex gap-4 overflow-hidden">
        {/* Note List */}
        <div className="w-1/3 border-r border-gray-200 pr-3 overflow-hidden">
          <div className="h-full overflow-y-auto pr-1">
            <div className="space-y-2">
              <div className="p-2.5 bg-blue-50 border border-blue-100 rounded-lg shadow-sm">
                <h4 className="font-semibold text-sm text-gray-900 mb-1">Project Kickoff</h4>
                <p className="text-xs text-gray-600 line-clamp-2">
                  Notes from our initial planning meeting...
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[10px] text-gray-500">Today, 10:42 AM</span>
                </div>
              </div>

              <div className="p-2.5 bg-white border border-gray-200 rounded-lg shadow-sm">
                <h4 className="font-semibold text-sm text-gray-900 mb-1">Marketing Ideas</h4>
                <p className="text-xs text-gray-600 line-clamp-2">
                  Campaign concepts for Q2 launch
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[10px] text-gray-500">Yesterday</span>
                </div>
              </div>

              <div className="p-2.5 bg-white border border-gray-200 rounded-lg shadow-sm">
                <h4 className="font-semibold text-sm text-gray-900 mb-1">User Feedback</h4>
                <p className="text-xs text-gray-600 line-clamp-2">
                  Collected feedback from user interviews...
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[10px] text-gray-500">Jan 15, 2023</span>
                </div>
              </div>

              <div className="p-2.5 bg-white border border-gray-200 rounded-lg shadow-sm">
                <h4 className="font-semibold text-sm text-gray-900 mb-1">Design System</h4>
                <p className="text-xs text-gray-600 line-clamp-2">
                  Components and guidelines for our UI
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[10px] text-gray-500">Jan 12, 2023</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Note Editor */}
        <div className="w-2/3 overflow-hidden">
          <div className="h-full overflow-y-auto pr-1">
            <div className="space-y-4">
              <h3 className="text-xl font-bold text-gray-800">Project Kickoff</h3>
              <div className="text-xs text-gray-500">Last edited: Today, 10:42 AM</div>

              <div className="prose prose-sm text-gray-700">
                <h4>Meeting Notes - Project Kickoff</h4>
                <p>
                  <strong>Date:</strong> January 18, 2023
                  <br />
                  <strong>Attendees:</strong> Sarah, Michael, David, Jennifer
                </p>

                <h5>Project Goals:</h5>
                <ul>
                  <li>Launch new product by end of Q2</li>
                  <li>Improve customer conversion rate by 15%</li>
                  <li>Establish stronger brand presence in target markets</li>
                </ul>

                <h5>Key Deliverables:</h5>
                <ol>
                  <li>Market research report (due Feb 15)</li>
                  <li>Product prototype (due March 10)</li>
                  <li>Marketing assets (due April 5)</li>
                  <li>Website updates (due April 20)</li>
                  <li>Launch campaign (due May 15)</li>
                </ol>

                <h5>Action Items:</h5>
                <ul>
                  <li>Sarah: Finalize budget approval by Friday</li>
                  <li>Michael: Schedule user research sessions</li>
                  <li>David: Draft product requirements document</li>
                  <li>Jennifer: Prepare competitive analysis</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const notesMockupData = {
  type: 'Notes',
  icon: FileText,
  description:
    'Capture and organize your ideas with our powerful note-taking system. Create rich-text notes with formatting, attach images and files, link related content together, and find everything instantly with powerful search.',
  mockup: <NotesMockup />,
};

export default NotesMockup;
